import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/personaReferencia";
import {
  PutHomologarPropietario,
  GetVerificarPropietarioDuplicado
} from "../../../reducers/personaReferencia";

export interface HomologarPropietarioDispatcher {
  putHomologarPropietario: (
    idMembresiaSocio: number,
    curp: string
  ) => Promise<Preview<PutHomologarPropietario>>;
  getVerificarPropietarioDuplicado: (
    idPropietario: number,
    curp: string
  ) => Promise<Preview<GetVerificarPropietarioDuplicado>>;
  clearPersonaReferencia: () => void;
}

export const homologarPropietarioDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => HomologarPropietarioDispatcher = dispatch => ({
  putHomologarPropietario: (idMembresiaSocio: number, curp: string) =>
    dispatch(actions.putHomologarPropietario(idMembresiaSocio, curp)),
  getVerificarPropietarioDuplicado: (idPropietario: number, curp: string) =>
    dispatch(actions.getVerificarPropietarioDuplicado(idPropietario, curp)),
  clearPersonaReferencia: () => dispatch(actions.clearPersonaReferencia())
});
